export { default as ContentCard } from './ContentCard';
